import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { PresubscriptionResourceService } from './presubscription-resource.service';
import { IPresubscriptionListResult } from './presubscription.interface';
import { SeasonID } from '../season-resource/season.interface';

@Injectable({ providedIn: 'root' })
export class AssignedPresubscriptionsResolver {
  private readonly presubscriptionResource = inject(
    PresubscriptionResourceService,
  );

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<IPresubscriptionListResult[]> {
    const id = route.queryParamMap.get('seasonId');
    const sort = route.queryParamMap.get('sort') || 'priority';
    return id
      ? this.presubscriptionResource.listAssigned(
          Number(id) as SeasonID,
          sort as 'priority' | 'name',
        )
      : of([]);
  }
}
